




















































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import Service from "@/services/RetensiAlihMediaService";
import { RetensiBatch, RetensiBerkas } from "@/types/RetensiAlihMedia";

@Component({ name: "RetensiDaftarBerkasTab" })
export default class DaftarBerkasTab extends Vue {
  @Prop({ type: Object, required: true }) batch!: RetensiBatch;
  @Prop({ type: Boolean, default: false }) readonly!: boolean;

  rows: RetensiBerkas[] = [];
  kandidat: RetensiBerkas[] = [];
  selected: RetensiBerkas[] = [];
  dialog = false;
  scanning = false;
  saving = false;

  scanForm = {
    tahun_terlama: 0,
    tahun_terbaru: 0,
    limit: 500,
  };

  kandidatHeaders = [
    { text: "No. RM", value: "no_rm" },
    { text: "Nama", value: "nama" },
    { text: "Umur", value: "umur" },
    { text: "Alamat", value: "alamat" },
    { text: "Diagnosa", value: "diagnosa" },
    { text: "Masuk", value: "tgl_masuk" },
    { text: "Keluar", value: "tgl_keluar" },
    { text: "Poli/Bangsal", value: "unit_nama" },
  ];

  async mounted() {
    await this.load();
  }

  get sudahTerdaftar(): number {
    return this.kandidat.filter((k) => k.sudah_terdaftar).length;
  }

  /** Baris yang sudah masuk daftar disembunyikan supaya tidak dipilih dua kali. */
  get kandidatBaru(): RetensiBerkas[] {
    return this.kandidat.filter((k) => !k.sudah_terdaftar);
  }

  /** http.getData/postData mengembalikan response axios mentah — body ada di res.data. */
  private unwrap(res: any): RetensiBerkas[] {
    const body = res && res.data !== undefined ? res.data : res;
    if (Array.isArray(body)) return body;

    return (body && body.data) || [];
  }

  async load() {
    this.rows = this.unwrap(await Service.listBerkas(this.batch.id as number));
  }

  openScan() {
    this.scanForm.tahun_terlama = this.batch.kunjungan_tahun_terlama as number;
    this.scanForm.tahun_terbaru = this.batch.kunjungan_tahun_terbaru as number;
    this.selected = [];
    this.kandidat = [];
    this.dialog = true;
  }

  async doScan() {
    this.scanning = true;
    try {
      const res = await Service.scanBerkas(this.batch.id as number, this.scanForm);
      this.kandidat = this.unwrap(res);
      this.selected = [];
    } finally {
      this.scanning = false;
    }
  }

  async tambah() {
    this.saving = true;
    try {
      await Service.tambahBerkas(
        this.batch.id as number,
        this.selected.map((s) => s.register_no as number)
      );
      this.dialog = false;
      await this.load();
      this.$emit("changed");
    } finally {
      this.saving = false;
    }
  }

  async simpanKeterangan(row: RetensiBerkas) {
    await Service.updateBerkas(row.id as number, row.keterangan);
  }

  async hapus(row: RetensiBerkas) {
    if (!confirm(`Hapus ${row.nama} (RM ${row.no_rm}) dari daftar?`)) return;
    await Service.deleteBerkas(row.id as number);
    await this.load();
    this.$emit("changed");
  }

  cetak() {
    window.open(Service.daftarBerkasPdfUrl(this.batch.id as number), "_blank");
  }

  formatDate(iso: string | null): string {
    if (!iso) return "—";
    return new Date(iso).toLocaleDateString("id-ID");
  }
}
